import { useState } from "react";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetails from "./pages/ProductDetails";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Payment from "./pages/Payment";
import Success from "./pages/Success";

import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

import Navbar from "./components/Navbar";
import ContactFloat from "./components/ContactFloat";

import CartProvider from "./context/CartContext";

import ProtectedRoute from "./components/ProtectedRoute";

/* ================= LAYOUT ================= */
const Layout = ({
  children,
  search,
  setSearch,
}) => {

  const location = useLocation();

  const hideUI =
    location.pathname === "/" ||
    location.pathname.startsWith("/admin") ||
    location.pathname === "/admin-login";

  return (
    <>

      {!hideUI && (
        <Navbar
          search={search}
          setSearch={setSearch}
        />
      )}

      {!hideUI && (
        <ContactFloat />
      )}

      {children}

    </>
  );
};

/* ================= APP ================= */
function App() {

  const [search, setSearch] =
    useState("");

  return (

    <CartProvider>

      <Router>

        <Layout
          search={search}
          setSearch={setSearch}
        >

          <Routes>

            <Route
              path="/"
              element={<Home />}
            />

            <Route
              path="/products"
              element={
                <Products
                  search={search}
                />
              }
            />

            <Route
              path="/product/:id"
              element={
                <ProductDetails />
              }
            />

            <Route
              path="/cart"
              element={<Cart />}
            />

            <Route
              path="/checkout"
              element={<Checkout />}
            />

            <Route
              path="/payment"
              element={<Payment />}
            />

            <Route
              path="/success"
              element={<Success />}
            />

            <Route
              path="/admin-login"
              element={<AdminLogin />}
            />

            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />

          </Routes>

        </Layout>

      </Router>

    </CartProvider>
  );
}

export default App;